export default {
  config: {
    apiKey: "AIzaSyBpMobXFG4VAe4ehFmDjHkS0yigWZ6gwTs",
    authDomain: "travel-treasury-landing-36d9f.firebaseapp.com",
    projectId: "travel-treasury-landing-36d9f",
    storageBucket: "travel-treasury-landing-36d9f.appspot.com",
    messagingSenderId: "784436195985",
    appId: "1:784436195985:web:57f2718b0f94dfde960530",
    measurementId: "G-3SFYDNJSV9"
  }
};



// WEBPACK FOOTER //
// ./src/firebase/credentials.js